import React from 'react'
import Helmet from 'react-helmet'
import Link from 'gatsby-link'
import get from 'lodash/get'
import anime from 'animejs'

import Footer from '../components/footer'
import ScrollBack from '../components/scrollback'

class BlogPostTemplate extends React.Component {
  componentDidMount(){
    var playPause = anime({
      targets: '.proj-head',
      opacity: {
        value: [0,1],
        delay: 0,
        duration: 250,
        easing: 'easeInOutCubic'
      }
    });
    var body = anime({
      targets: '.project-width',
      opacity: {
        value: [0,1],
        delay: 0,
        duration: 400,
        easing: 'easeInOutQuart'
      }
    });
  }

  render() {
    const post = this.props.data.markdownRemark
    const siteTitle = get(this.props, 'data.site.siteMetadata.title')
    const header = post.frontmatter.header.childImageSharp.resize.src;
    const color = post.frontmatter.color;
    const active = post.frontmatter.active;
    const tags = post.frontmatter.tags;

    return (
      <div>
        <ScrollBack top={90} visible={false}/>
      <div className="proj-head" style={{
          width: "100%",
          height: "60vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          backgroundImage: `linear-gradient(45deg, ${color[0]}, ${color[1]}),url("${header}")`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          fontSize: "3em",
          padding: "1em",
          fontWeight: 400,
          textAlign: "center",
          color: "white"
        }}>
        </div>
      <div className="project-width">
        <Helmet title={`${post.frontmatter.title} | ${siteTitle}`} />
      <h1 style={{
        fontSize: "2em",
        fontWeight: 500,
        marginTop: "1.5em",
        marginBottom: ".2em",
        paddingBottom: ".25em",
        }}>{post.frontmatter.title}</h1>
      <div style={{
        marginBottom: "1.5em",
        paddingBottom: "1em",
        borderBottom: "1px solid #eeeeee"
      }}>
      {tags.map((tag, i)=>
        <span className="tag-button">{tag}</span>
      )}</div>
    {(active)?<div className="active-notice">This project is currently active and being regularly updated</div> : null}
      <div className="project-body" dangerouslySetInnerHTML={{ __html: post.html }} />
      </div>
      <Footer />
    </div>
    )
  }
}

export default BlogPostTemplate

export const pageQuery = graphql`
  query ProjectPostByPath($path: String!) {
    site {
      siteMetadata {
        title
        author
      }
    }
    markdownRemark(frontmatter: { path: { eq: $path } }) {
      id
      html
      frontmatter {
        title
        color
        active
        tags
        header {
          childImageSharp {
            resize(width: 1200) {
              src
            }
          }
        }
        # date(formatString: "MMMM DD, YYYY")
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/templates/project-post.js